import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowRefService {

  constructor() { }
  open(url: string, target = '_blank') {
    window.open(url, target )
  }
}
